import { countMembers, getOrgSummary } from '@mesa/core/org/queries';
import { createServerFn } from '@tanstack/react-start';
import { assertScope, baseAuthMiddleware } from '../../middleware/base-auth';

export const loadSettingsPage = createServerFn({ method: 'GET' })
  .middleware([baseAuthMiddleware])
  .validator((data: { orgSlug: string }) => data)
  .handler(async ({ context }) => {
    assertScope(context.member.role, 'admin');

    const [{ repoCount }, memberCount] = await Promise.all([
      getOrgSummary(context.org.id, { repoIds: null }),
      countMembers(context.org.id),
    ]);

    return { repoCount, memberCount };
  });
